import { Service, CONTACT_INFO } from "@/lib/index";

export const COMPANY_INFO = {
  ...CONTACT_INFO,
  history: "Établie au cœur de la SIPIM Port-Bouët, YKE Multi_Services s'est imposée comme une référence de l'excellence et de la polyvalence en Côte d'Ivoire. Notre mission est d'accompagner une clientèle exigeante à travers des services de prestige alliant luxe, confort et sécurité foncière.",
  vision: "Devenir le partenaire incontournable pour tout projet de vie ou d'investissement en Côte d'Ivoire, en garantissant une qualité de service irréprochable.",
  values: ["Intégrité", "Excellence", "Proximité", "Innovation"],
  year: 2026
};

export const HERO_DATA = {
  title: "L'Excellence au Service de Vos Ambitions",
  subtitle: "Découvrez notre univers de prestige : vins d'exception, résidences de haut standing et solutions foncières sécurisées à Abidjan et ses environs.",
  primaryCTA: "Explorer nos services",
  secondaryCTA: "Nous contacter",
};

export const SERVICES_DATA: Service[] = [
  {
    id: "vins-et-champagnes",
    title: "Vins & Champagnes d'Exception",
    description: "Une sélection rigoureuse des meilleurs crus importés et champagnes de prestige pour sublimer vos événements.",
    fullDescription: "En tant qu'importateur direct, YKE Multi_Services vous propose une cave d'exception. Nous parcourons les vignobles internationaux pour vous offrir des bouteilles rares, des champagnes de grandes maisons et des vins de garde qui satisferont les palais les plus raffinés de Côte d'Ivoire.",
    imageKey: "WINE_CHAMPAGNE_1",
    category: "wine",
    features: [
      "Importation directe de vignobles renommés",
      "Service de conciergerie pour événements",
      "Livraison sécurisée à Abidjan",
      "Conseils personnalisés en sommellerie"
    ]
  },
  {
    id: "residences-meublees",
    title: "Résidences de Haut Standing",
    description: "Des séjours inoubliables dans nos appartements et villas meublés à Bassam, Abidjan et Assini.",
    fullDescription: "Que ce soit pour un voyage d'affaires à Abidjan ou un week-end de détente à Assini ou Grand-Bassam, nos résidences offrent un confort inégalé. Chaque espace est décoré avec soin, entièrement équipé et situé dans des zones sécurisées pour garantir votre tranquillité.",
    imageKey: "FURNISHED_RESIDENCE_1",
    category: "residence",
    locations: ["Bassam", "Abidjan", "Assini"],
    features: [
      "Emplacements stratégiques et sécurisés",
      "Équipements modernes et haut de gamme",
      "Service de ménage et maintenance",
      "Connexion internet haute vitesse"
    ]
  },
  {
    id: "terrains-et-lotissement",
    title: "Expertise Foncière & Lotissement",
    description: "Vente de terrains sécurisés et gestion de projets de lotissement avec toutes les garanties juridiques.",
    fullDescription: "Investir dans l'immobilier demande de la confiance. YKE Multi_Services vous accompagne dans l'acquisition de parcelles loties et approuvées. Nous gérons le processus de lotissement de A à Z, assurant la transparence totale et la sécurisation de votre patrimoine foncier.",
    imageKey: "LAND_DEVELOPMENT_1",
    category: "land",
    features: [
      "Vérification juridique rigoureuse",
      "Terrains avec ACD ou titres sécurisés",
      "Projets de lotissement structurés",
      "Accompagnement administratif personnalisé"
    ]
  }
];
